export const safdieArchitectsContent = (
  <div className="prose dark:prose-invert max-w-none text-text-muted-light dark:text-text-muted-dark">
    <h2>The Client</h2>
    <p>
      Safdie Architects is internationally known for museums, cultural
      buildings, and large-scale urban work you have probably seen in the news
      or walked through on vacation. Their reputation is built on physical
      spaces that feel inevitable once they exist&mdash;the bar for anything
      carrying their name online is high.
    </p>

    <h2>What We Built</h2>
    <p>
      We designed and built a portfolio site for their team: a calm, confident
      frame around the work, with room for long-form project storytelling,
      strong typography, and motion that supports comprehension instead of
      competing with the imagery.
    </p>
    <p>
      Underneath, it is built so their studio can keep publishing new projects
      and geographies without fighting the layout. The point was never a flashy
      one-off; it was a beautiful, durable home for a body of work that deserves
      to be shown with the same seriousness as the buildings themselves.
    </p>
  </div>
);
